import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { parseHomeHeroContent } from '../utils/homeHeroContent';

export const useHomeHeroContent = () => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const page = await getPublicPage('home');
        if (!isMounted) {
          return;
        }

        setContent(parseHomeHeroContent(page));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { content, isLoading, error };
};
